// extracted by mini-css-extract-plugin
export default {"warning":"Warning_warning__FfP9Q"};